// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-message-box__message{width:80%;display:inline-block;word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
